import { useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import auth from "../service/auth";
import Login from "./Login";

const NAV = [
  { to: "/", label: "Dashboard", icon: "📊", exact: true },
  { to: "/organizations", label: "Organizations", icon: "🏢" },
  { to: "/applications", label: "Applications", icon: "📱" },
  { to: "/users", label: "Users", icon: "👤" },
  { to: "/campaigns", label: "Campaigns", icon: "📣" },
  { to: "/tokens", label: "Tokens", icon: "🔑" },
  { to: "/tickets", label: "Tickets", icon: "🎫" },
];

const Layout = () => {
  const location = useLocation();
  const [user, setUser] = useState(auth.user());
  const [menuOpen, setMenuOpen] = useState(false);

  const logout = () => {
    auth.logout();
    setUser(null);
  };

  const isActive = (item) =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 flex items-center justify-center p-4">
        <Login setUser={setUser} />
      </div>
    );
  }

  const navContent = (
    <>
      <div className="px-5 py-6 border-b border-slate-700/50">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-lg shadow-lg shadow-indigo-500/30">
            🔔
          </div>
          <div>
            <div className="font-bold text-white leading-tight">Push Service</div>
            <div className="text-xs text-slate-400">Notification Platform</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            onClick={() => setMenuOpen(false)}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              isActive(item)
                ? "bg-indigo-600 text-white shadow-lg shadow-indigo-600/30"
                : "text-slate-300 hover:bg-slate-800 hover:text-white"
            }`}
          >
            <span className="text-base">{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="px-3 py-4 border-t border-slate-700/50">
        <div className="flex items-center gap-3 px-3 py-2">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-sm text-white">
            {(user.name || user.email || "?").charAt(0).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm text-white truncate">{user.name || user.email}</div>
          </div>
          <button
            onClick={logout}
            title="Déconnexion"
            className="text-slate-400 hover:text-rose-400 transition-colors text-lg"
          >
            ⏻
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div className="flex h-screen bg-slate-100">
      {/* Sidebar desktop */}
      <aside className="hidden md:flex md:flex-col w-64 bg-slate-900 shrink-0">
        {navContent}
      </aside>

      {/* Topbar mobile */}
      <div className="md:hidden fixed top-0 inset-x-0 z-20 bg-slate-900 flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2 text-white font-bold">
          <span>🔔</span> Push Service
        </div>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-white text-2xl leading-none px-2"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Drawer mobile */}
      {menuOpen && (
        <div className="md:hidden fixed inset-0 z-10 flex" onClick={() => setMenuOpen(false)}>
          <aside
            className="w-64 bg-slate-900 flex flex-col pt-14"
            onClick={(e) => e.stopPropagation()}
          >
            {navContent}
          </aside>
          <div className="flex-1 bg-black/40" />
        </div>
      )}

      {/* Contenu */}
      <main className="flex-1 overflow-y-auto pt-14 md:pt-0">
        <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
